import styled from 'styled-components';
import colors, { opacify } from '../../utils/colors';
import { heights, zIndices } from '../../utils/theme';
import typography from '../../utils/typography';
const { mainCopy } = typography;
const { blend, midnight, white, skyDarkest, lightGrey, lightBlue, black } = colors;
export const StyledDropdownHeader = styled.h2({
    display: 'grid',
    textAlign: 'left',
    color: midnight,
    margin: 0,
    padding: '0.75rem 1.5rem',
    borderBottom: `1px solid ${lightGrey}`,
});
export const StyledDropdownMenu = styled.div({
    backgroundColor: white,
    minWidth: '180px',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    filter: `drop-shadow(0px 4px 30px ${opacify(black, 0.25)})`,
    borderRadius: '5px',
    zIndex: zIndices.dropdown,
});
export const StyledDropdownItem = styled.button(mainCopy, {
    boxSizing: 'border-box',
    cursor: 'pointer',
    width: '-webkit-fill-available',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '0.75rem 1.5rem',
    gap: '0.75rem',
    color: midnight,
    backgroundColor: 'inherit',
    textDecoration: 'none',
    textAlign: 'left',
    listStyleType: 'none',
    border: '2px solid transparent',
    borderRadius: '5px',
    svg: {
        flexShrink: 0,
        width: heights.menuIcon,
        height: heights.menuIcon,
        color: skyDarkest,
    },
    '&:active, &[data-active="true"]': {
        backgroundColor: blend,
    },
    '&:focus-visible': {
        outline: 'none',
        border: `2px solid ${skyDarkest}`,
    },
    '&:hover': {
        backgroundColor: lightBlue,
    },
});
